import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";
import {
  getCategoryForMachine,
  getProductForMachine,
  getProductVariantForMachine,
  getSubCategoryForMachine,
} from "data/server_apis/commodityService";

// const variantAdapter = createEntityAdapter({
//   selectId: (variant) => variant.id,
// });

const initialState = {
  category: [],
  sub_category: [],
  products: [],
  variants: [],
};

export const getCategoryForMachineThunk = createAsyncThunk(
  "commodity/getCategoryForMachine",
  async (machine, { rejectWithValue }) => {
    try {
      return (await getCategoryForMachine(machine)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getSubCategoryForMachineThunk = createAsyncThunk(
  "commodity/getSubCategoryForMachine",
  async ({ machine, category }, { rejectWithValue }) => {
    try {
      return (await getSubCategoryForMachine(machine, category)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getProductForMachineThunk = createAsyncThunk(
  "commodity/getProductForMachine",
  async ({ machine, sub_category }, { rejectWithValue }) => {
    try {
      return (await getProductForMachine(machine, sub_category)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getProductVariantForMachineThunk = createAsyncThunk(
  "commodity/getProductVariantForMachine",
  async ({ machine, product }, { rejectWithValue }) => {
    try {
      return (await getProductVariantForMachine(machine, product)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const productsForMachineSlice = createSlice({
  name: "commodityForMachine",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCategoryForMachineThunk.fulfilled, (state, action) => {
      state.category = action.payload;
    });

    builder.addCase(
      getSubCategoryForMachineThunk.fulfilled,
      (state, action) => {
        state.sub_category = action.payload;
      }
    );

    builder.addCase(getProductForMachineThunk.fulfilled, (state, action) => {
      state.products = action.payload;
    });

    builder.addCase(
      getProductVariantForMachineThunk.fulfilled,
      (state, action) => {
        state.variants = action.payload;
      }
    );
  },
});

export const {} = productsForMachineSlice.actions;

export default productsForMachineSlice.reducer;
